module.exports = __webpack_public_path__ + "assets/certificate_pdf/ssa_110_20.0e9ac009.pdf";